import React from 'react'
import { AlertTriangle } from 'lucide-react'
import Button from '../../../../components/ui/button'

export const ScriptErrorState: React.FC<{
  errorMessage?: string | null
  onRetry: () => void
}> = ({ errorMessage, onRetry }) => (
  <div className="p-8 flex items-center justify-center min-h-[400px]">
    <div className="text-center max-w-md">
      <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-danger-50 flex items-center justify-center ring-1 ring-inset ring-danger-600/20">
        <AlertTriangle className="w-6 h-6 text-danger-600" />
      </div>
      <h3 className="text-lg font-medium text-foreground mb-2">We couldn't generate your script</h3>
      <p className="text-sm text-foreground/60 mb-4">{errorMessage || 'Something went wrong. Please try again.'}</p>
      <div className="flex items-center justify-center gap-3">
        <Button onClick={onRetry} className="gap-2">
          Retry
        </Button>
      </div>
    </div>
  </div>
)
